/** Native lazy-loading: first slide of first panel loads eagerly for LCP; rest defer. */
export function introCarouselImgAttrs(panelIndex: number | string, slideIndex: number | string) {
  const firstVisible = Number(panelIndex) === 0 && Number(slideIndex) === 0;
  return {
    loading: firstVisible ? ('eager' as const) : ('lazy' as const),
    decoding: 'async' as const,
    ...(firstVisible ? { fetchpriority: 'high' as const } : {}),
  };
}

/** Category / small icons: defer until near viewport. */
export function lazyImageAttrs() {
  return {
    loading: 'lazy' as const,
    decoding: 'async' as const,
  };
}

/** Business listing thumbnails: defer (list can be long). */
export function businessListingImgAttrs(index: number | string) {
  const n = Number(index);
  return {
    loading: n < 2 ? ('eager' as const) : ('lazy' as const),
    decoding: 'async' as const,
  };
}
